export default {
  getHistories: ({histories}) => histories,
  isHistoriesFetched: ({isHistoriesFetched}) => isHistoriesFetched,
  isFetchingHistories: ({isFetchingHistories}) => isFetchingHistories,
  getHistoriesLoadedLength: ({historiesLoadedLength}) => historiesLoadedLength,
}